import type { ReactNode } from 'react';
import {
  Box,
  Column,
  FloatingContainer,
  Row,
  Screen,
  Stepper,
  Text,
  ZStack,
} from '~/commonComponents';
import { BackButtonProxy as BackButton } from '~/commonComponents/BackButton';

const SHIFT_REQUEST_STEPS = ['Select Dates', 'Shift Details', 'Review & Confirm'];

interface IShiftRequestHeaderProps {
  currentStep: number;
  onBack?: () => void;
  backUrl?: string;
  maxWidth?: number;
  children: ReactNode;
}

export const ShiftRequestHeader = ({
  currentStep,
  onBack,
  backUrl,
  maxWidth,
  children,
}: IShiftRequestHeaderProps) => (
  <Screen minWidth={768} paddingInline={30} paddingTop={16} paddingBottom={16}>
    <FloatingContainer
      justifyContent="flex-start"
      maxWidth={maxWidth}
      borderRadius={0}
      margin={0}
      minWidth={0}
      width="100%"
      alignSelf="center"
      height="100%"
    >
      <Row alignItems="center" marginTop={60} position="relative">
        <ZStack left={20}>
          <BackButton onClick={onBack} url={backUrl} />
        </ZStack>
        <Text bold fontSize={28} textAlign="center" flex={1}>
          Shift Request
        </Text>
      </Row>
      <Column paddingHorizontal={28} paddingTop={24} paddingBottom={60}>
        <Box maxWidth={512} margin="0 auto" width="100%">
          <Stepper steps={SHIFT_REQUEST_STEPS} currentStep={currentStep} />
        </Box>
        {children}
      </Column>
    </FloatingContainer>
  </Screen>
);
